/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum Flag {
  None = 'NONE',
  Estimated = 'ESTIMATED',
  Target = 'TARGET'
}
